import React from 'react';
import { MenuItemType } from '../../../../ui';
import { PencilIcon, TrashIcon } from '../../../../ui/icons/icons';
import { Permission } from '../../../../utils/helpers/permissions';
import { OrganizationUser } from '../../../../utils/types/admin_types';

interface IMenuItemsColumns {
  onDelete: (row: OrganizationUser) => void;
}

export const getMenuItemsForMenu = ({
  onDelete,
}: IMenuItemsColumns): MenuItemType<OrganizationUser>[] => {
  const menuItems: MenuItemType<OrganizationUser>[] = [
    {
      label: 'Delete Item',
      icon: <TrashIcon />,
      permission: [Permission.USERS_DELETE],
      onClick: (row) => onDelete(row),
    },
  ];
  return menuItems; // <-- Add this line to return the array!
};
